import React, {Component} from 'react'
import {connectCurrentRefinements} from 'react-instantsearch-dom'
import {CloseSmallIcon} from '../../../icons'
import {formatCurrencyByLocale} from '../../../../util/formatCurrencyByLocale'

class CurrentRefinements extends Component {
  constructor(props) {
    super(props)
    this.handleCheck = this.handleCheck.bind(this)
  }

  handleCheck(value) {
    this.props.refine(value)
  }

  componentDidUpdate() {
    const { items, setNumberRefinements, refinementCount } = this.props

    let rawFilters = []

    items &&
      items.map(e => {
        if (
          e.attribute !== `named_tags.assetcondition` &&
          e.attribute !== `collections` &&
          e.attribute !== `query` &&
          e.items &&
          e.items.length != 0
        ) {
          e &&
            e.items &&
            e.items.map(a => {
              rawFilters.push(a)
            })
        }
      })
    if (rawFilters.length != refinementCount) {
      setNumberRefinements(rawFilters.length)
    }
  }

  refinementsWithNoItems(item) {
    if (
      item.attribute === `price`
    ) {
      const moneyFormat = window.theme.moneyFormat
      const formattedMin = formatCurrencyByLocale({ amount: item.currentRefinement.min * 100, format: moneyFormat })
      const formattedMax = formatCurrencyByLocale({ amount: item.currentRefinement.max * 100, format: moneyFormat })

      return (
        <div className="refinements-list">
          <div className="refinement-wrapper">
            <a
              onClick={event => {
                event.preventDefault()
                this.handleCheck(item.value)
              }}
              className="refinement-text"
            >
              Price ({<span dangerouslySetInnerHTML={{ __html: formattedMin }}></span>} - {<span dangerouslySetInnerHTML={{ __html: formattedMax }}></span>})

              <div className="inline-block padding-left-1x remove-line-height">
                <CloseSmallIcon />
              </div>
            </a>
          </div>
        </div>
      )
    }

    return (
      <div>
        {item.label.includes(`collections:`) ||
        item.label.includes(`query:`) ? null : (
          <a
            onClick={event => {
              event.preventDefault()
              this.handleCheck(item.value)
            }}
          >
            {item.label}
          </a>
        )}
      </div>
    )
  }

  render() {
    const {
      items,
      currentRefinement,
      refine,
      dropdownState,
      dropdown,
      label,
      createURL,
      setNumberRefinements,
      refinementCount
    } = this.props

    return (refinementCount || (items.length && items.some(item => {
      return item.attribute !== undefined
    })) ) ? (
      <div className="filter-list__selected-refinements">
        <div className="refinements">
          <ul>

            {items.map((item, index) => {
              if (item.label.includes(`assetcondition:`)) {
                return null
              }
              return (
                <li key={item.label + index} className={`attribute-${item.attribute}`}>
                  {item.items ? (
                    <React.Fragment>
                      <ul className="refinements-list">
                        {item.items.map((element) => {
                          return (
                            <li
                              key={element.label + index}
                              className="refinement-wrapper"
                              onClick={event => {
                                event.preventDefault()
                                this.handleCheck(element.value)
                              }}
                            >
                              <a className="refinement-text">{element.label}</a>
                              <CloseSmallIcon />
                            </li>
                          )
                        })}
                      </ul>
                    </React.Fragment>
                  ) : this.refinementsWithNoItems(item)}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    ) : null
  }
}

const Refinements = connectCurrentRefinements(CurrentRefinements)

export default Refinements
